import ResetPasswordForm from 'components/ResetPasswordForm';
import React, { useState, useContext, useEffect } from 'react';
import { Card, Col, Row } from 'reactstrap';
import { AuthContext } from 'src/authentication/AuthContext';
import {
  checkConfirmPassword,
  checkPasswordStrength,
} from 'src/admin/password';
import { resetPasswordAdmin } from 'src/admin/adminService';

const ResetPasswordPage = (props) => {
  const [formState, setFormState] = useState({
    password: '',
    confirmPassword: '',
    passwordErrMsg: '',
    confirmPasswordErrMsg: '',
  });
  const { signout, setToken } = useContext(AuthContext);

  const onChange = (key) => (event) => {
    setFormState((prevState) => ({
      ...prevState,
      [key]: event.target.value,
    }));
  };

  useEffect(() => {
    setFormState((prevState) => ({
      ...prevState,
      passwordErrMsg: checkPasswordStrength(formState.password),
      confirmPasswordErrMsg: checkConfirmPassword(
        formState.confirmPassword,
        formState.password,
      ),
    }));
  }, [formState.password, formState.confirmPassword]);

  const onSubmit = async (e) => {
    if (!formState.password) {
      alert('Password is required!');
      return;
    }
    if (!formState.confirmPassword) {
      alert('Confirm password is required!');
      return;
    }
    try {
      const res = await resetPasswordAdmin({
        password: formState.password,
        confirmPassword: formState.confirmPassword,
      });
      setToken(res.data.token);
      alert('Reset your password sucessfully');
      props.history.push('/');
    } catch (err) {
      console.error('There was an error reset your password!', err);
      alert(err.message);
    }

    e.preventDefault();
  };

  const onCancel = () => {
    signout();
  };

  return (
    <Row
      style={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Col md={6} lg={4}>
        <Card body>
          <ResetPasswordForm
            passwordInputProps={{ onChange: onChange('password') }}
            confirmPasswordInputProps={{
              onChange: onChange('confirmPassword'),
            }}
            passwordErrMsg={formState.passwordErrMsg}
            confirmPasswordErrMsg={formState.confirmPasswordErrMsg}
            onSubmit={onSubmit}
            onCancel={onCancel}
          />
        </Card>
      </Col>
    </Row>
  );
};
export default ResetPasswordPage;
